<template>
  <div class="article-a pointer">
    <p class="type" :style="{color: tagFontColor, backgroundColor: tagColor}">{{type}}</p>
    <div class="name">
      <p class="font_14_black article-title">{{title}}</p>
      <p class="font_14_gray time">{{date}}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    type: String, // 文章类型
    title: String, // 文章标题
    date: String, // 文章日期
    tagColor: String, // 标签背景色
    tagFontColor: String // 标签文字颜色
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.article-a {
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #e5e5e5;
  .type {
    align-self: flex-start;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    // width: 76px;
    height: 24px;
    font-size: 14px;
    color: #f26828;
    background-color: #fdf0ea;
    border-radius: 8px;
  }
  .name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 14px;
    padding-bottom: 18px;
  }
  .article-title {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .time {
    white-space: nowrap;
  }
}
</style>